var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BCarousel',{attrs:{"indicator":false}},_vm._l((9),function(n){return _c('BCarouselItem',{key:n},[_c('section',[_c('div',{staticClass:"retro-carousel__image-container"},[_c('img',{attrs:{"src":`/images/retro/${_vm.screenType}/${n}.png`,"alt":"retro"}})])])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }